module.exports = __webpack_public_path__ + "img/icons_23.4636d6a3.svg";